import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { FileText, ArrowLeft } from 'lucide-react';

export default function TermsPage() {
  return (
    <div className="container py-8 px-4 md:px-6">
      <div className="max-w-3xl mx-auto">
        <div className="flex items-center gap-4 mb-8">
          <Button variant="ghost" size="icon" asChild>
            <Link to="/">
              <ArrowLeft className="h-5 w-5" />
            </Link>
          </Button>
          <div>
            <h1 className="text-3xl font-bold">Terms of Service</h1>
            <p className="text-muted-foreground">Last updated: March 1, 2025</p>
          </div>
        </div>

        <Card className="mb-8">
          <CardHeader>
            <div className="flex items-center gap-2">
              <FileText className="h-5 w-5 text-primary" />
              <CardTitle>Terms and Conditions</CardTitle>
            </div>
          </CardHeader>
          <CardContent className="prose dark:prose-invert max-w-none">
            <p>
              Welcome to NewLoop. By accessing or using our platform, you agree to be bound by these
              Terms of Service.
            </p>

            <h2>1. Acceptance of Terms</h2>
            <p>
              By accessing or using NewLoop, you agree to be bound by these Terms of Service and all
              applicable laws and regulations. If you do not agree with any of these terms, you are
              prohibited from using or accessing this platform.
            </p>

            <h2>2. User Accounts</h2>
            <p>Users are responsible for:</p>
            <ul>
              <li>Maintaining account security</li>
              <li>Providing accurate information</li>
              <li>Updating account information</li>
              <li>Complying with platform rules</li>
            </ul>

            <h2>3. Platform Usage</h2>
            <p>Users agree to:</p>
            <ul>
              <li>Use the platform legally and ethically</li>
              <li>Not misrepresent information</li>
              <li>Respect other users' rights</li>
              <li>Follow community guidelines</li>
            </ul>

            <h2>4. Content and Intellectual Property</h2>
            <p>
              Users retain ownership of their content but grant NewLoop a license to use, modify, and
              display the content for platform purposes.
            </p>

            <h2>5. Premium Services</h2>
            <p>
              Premium features require a subscription. Billing terms and conditions apply to premium
              services.
            </p>

            <h2>6. Termination</h2>
            <p>
              We reserve the right to terminate or suspend accounts that violate these terms or for any
              other reason.
            </p>

            <h2>7. Limitation of Liability</h2>
            <p>
              NewLoop is provided "as is" without warranties. We are not liable for any damages arising
              from platform use.
            </p>

            <h2>8. Changes to Terms</h2>
            <p>
              We may modify these terms at any time. Continued use of the platform constitutes
              acceptance of modified terms.
            </p>

            <h2>9. Governing Law</h2>
            <p>
              These terms are governed by and construed in accordance with the laws of the United
              States.
            </p>

            <h2>Contact</h2>
            <p>
              Questions about the Terms of Service should be sent to{' '}
              <a href="mailto:legal@newloop.dev">legal@newloop.dev</a>.
            </p>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}